import styled, {css} from 'styled-components'

export const StyledSupportedUser = styled.div`
    ${({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing}px;
        padding: ${spacing * 2}px ${spacing}px;
        border-bottom: 0.8px solid ${palette.neutral[400]};
    `}
`
export const StyledSupportedUserContent = styled.div`
    ${() => css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
    `}
`

export const StyledSupportedUserInform = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StyledSupportedUserLastPaymentDate = styled.div`
    ${({theme: {typography, palette}}) => css`
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: space-between;
        & span {
            ${typography.textXs};
            color: ${palette.neutral[500]};
            font-style: normal;
            font-weight: 400;
            line-height: 16.8px; /* 140% */
            flex: 1;
            max-width: 220px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: keep-all;
            white-space: normal;
        }
        & .date {
            white-space: nowrap;
        }
    `}
`

export const StyledSupportedUserInformName = styled.span`
    ${({theme: {palette}}) => css`
        max-width: 115px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${palette.primary[900]};
        font-style: normal;
        font-weight: 700;
        line-height: 19.6px; /* 140% */
    `}
`

export const StyledSupportedUserInformAmount = styled.span`
    ${({theme: {palette, spacing, typography}}) => css`
        ${typography.textLg}
        gap: ${spacing / 4}px;
        display: flex;
        align-items: center;
        font-weight: 700;
        color: ${palette.primary[900]};
    `}
`

export const radioInputStyles = () => css`
    label {
        font-weight: 400;
    }
`
export const StyledPaymentError = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing / 2}px;
        color: #00063d;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 19.6px; /* 108.889% */
    `}
`
